import misc from './misc/index';
import trackEditor from './trackEditor';

export default {
  misc,
  trackEditor
}



// WEBPACK FOOTER //
// ./src/locales/no/component/module/artist/index.js